import { Box, Typography, CircularProgress } from "@mui/material";
import { formatCurrency } from "../../../utils/formatCurrency";
import { BankTransaction } from "./OrderAssociateComponent";
import { isWithinThreePercentRange } from "./utils";
import { useOrdersPaymentsByBankTransactionId } from "../../../api/useOrdersByBankTransactionId";

type TotalAmountOfAssociatedOrdersProps = {
    type: "list" | "detail";
    bankTransaction: BankTransaction;
    orders?: Array<any>;
};

export const TotalAmountOfAssociatedOrders = ({ bankTransaction, orders, type }: TotalAmountOfAssociatedOrdersProps) => {
    const { data: fetchedPayments, isLoading } = useOrdersPaymentsByBankTransactionId(bankTransaction?.id);

    const paymentsToUse = orders || fetchedPayments || [];
 
    if (isLoading && !orders) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center">
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (paymentsToUse.length === 0) {
        return null;
    }

    const total = paymentsToUse.reduce((acc: number, payment: any) => acc + (Number(payment.amount) || 0), 0);

    const isPOSorOnlinePayment =
        bankTransaction?.category?.id === 91 || bankTransaction?.category?.id === 117 || bankTransaction?.category?.id === 124;

    const bankTransactionAmount = parseFloat(bankTransaction?.amount);
    const isExactMatch = total === bankTransactionAmount;
    const isWithinRange = isWithinThreePercentRange(total, bankTransaction?.amount);

    const color = isPOSorOnlinePayment ? (isWithinRange ? "#2ECDA7" : "error.main") : (isExactMatch ? "#2ECDA7" : "error.main");

    // Calculate the commission amount and percentage (only for POS/Online payments).
    const commissionAmount = isPOSorOnlinePayment ? total - parseFloat(bankTransaction?.amount) : 0;
    const commissionPercentage = isPOSorOnlinePayment ? (commissionAmount / total) * 100 : 0;

    return (
        <Box>
            {type === "detail" && <Typography variant="body1">Total de compras associadas</Typography>}
            <Typography variant={type === "detail" ? "h5" : "body1"} color={color}>
                {formatCurrency(total)}
            </Typography>
            {isPOSorOnlinePayment && (
                <Typography variant="caption" color="text.secondary">
                    Comissão: {formatCurrency(commissionAmount)} ({commissionPercentage.toFixed(2)}%)
                </Typography>
            )}
        </Box>
    );
};
